$(document).ready(function () {
    $('#addassignment').on('show.bs.modal', function (e) {
        var acyr = $('ul.acyr-filter li.active').text().trim();
        $(this).find('input[type="hidden"][name="acyr"]').val(acyr);
    });

    $('[id^="editassignment"]').on('show.bs.modal', function (e) {
        var buttonId = e.target.id;
        var assignmentId = buttonId.substring(14);
        $('#deadline_' + assignmentId).val($('input[type="hidden"][name="assignment_deadline_' + assignmentId + '"]').val());
    });
});
